<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Navbar from '../module/Navbar'
import {mapGetters} from "vuex";


export default {
  name: "ParentMixin",
  components:{ 
    VueSlickCarousel,
    Navbar
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ])
  },
  data(){
    return {
      isMobile:false,
      settings: {
          "focusOnSelect": true,
          "infinite": false,
          "slidesToShow": 1,
          "variableWidth": true,
          "speed": 500,
          "initialSlide": 0,
          "arrow":false
      }       
    }
  },
  created (){
      this.isMobile = this.getIsMobile;
  },    
  methods : {

  },
  watch : {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
}
</script>